import { FC, memo } from 'react';

import { H1, H2 } from '../../components/heading/Hx';
import Paragraph from '../../components/paragraph/Paragraph';
import Section from '../../components/section/Section';
import Video from '../../components/video/Video';
import { COLOR } from '../../theme/type';

const Extrem: FC = () => (
  <Section background={COLOR.Dark1}>
    <H1 color={COLOR.Gold1} sx={{ position: 'static' }}>
      Selbstverteidigung Extrem
    </H1>

    <H2>Überleben im Ernstfall - Deine Sicherheit zählt</H2>

    <Paragraph>
      "Selbstverteidigung Extrem" ist genau das Richtige für Dich, wenn Du Deine Sicherheit und die
      Deiner Familie ernst nimmst. Egal, ob Du wenig Zeit für regelmäßiges Training hast oder Dich
      körperlich unterlegen fühlst – wir sind hier, um dir zu helfen!
    </Paragraph>

    <Video margin={{ y: { md: '1.5rem', xs: '1rem' } }} no-margin src={'399697424'} />

    <Paragraph>
      Stell Dir vor, Du befindest Dich in einer kritischen Situation und hast keine Ahnung, wie Du
      reagieren sollst. Die Szenarien, die Du Dir ausgemalt hast, funktionieren oft nicht in der
      Realität. Es ist weitaus herausfordernder, einen Angreifer außer Gefecht zu setzen, als es
      Videos im Internet vermuten lassen. Wenn Du dann unter Stress stehst, kann es schockierend
      sein zu erkennen, dass Deine Fähigkeiten nicht ausreichen. Wie würdest Du mit dieser
      Hilflosigkeit und diesem Stress umgehen?
    </Paragraph>

    <Paragraph>
      Wenn Du Dich nicht wehrst, könnte das fatale Folgen haben – von traumatischen Erlebnissen bis
      hin zu schweren Verletzungen. Der Gedanke daran, möglicherweise im Koma zu liegen oder
      unerwartet schwanger zu werden, ist erschreckend. Darüber hinaus kann ein solcher Vorfall
      körperliche und seelische Narben hinterlassen, die ein Leben lang bleiben.
    </Paragraph>

    <Paragraph>
      Angst zu haben bedeutet nicht, ein Feigling zu sein. Du kannst Deine Überlebenschancen von 0%
      auf 10% oder mehr steigern! Anstatt unzählige Stunden in intensives Training zu investieren,
      bietet Dir "Selbstverteidigung Extrem" die Möglichkeit, Dir gezielte Kenntnisse anzueignen,
      Dein Mindset zu schärfen und effektive Techniken für den Ernstfall zu erlernen.
    </Paragraph>

    <Paragraph>
      "Selbstverteidigung Extrem" ist ein brutales Programm, das Dich auf Notlagen vorbereitet. Du
      wirst lernen, gezielt Nerven- und Vitalpunkte anzugreifen, Hilfsmittel zu nutzen und jede
      Gelegenheit zu ergreifen, die Dir zur Verfügung steht.
    </Paragraph>

    <Paragraph>
      Schütze Dich und Deine Liebsten – investiere in Deine Sicherheit und erlerne Fähigkeiten, die
      Dir im Notfall das Leben retten können!
    </Paragraph>
  </Section>
);

export default memo(Extrem);
